export default "__VITE_ASSET__CHapCVJd__"